import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


export const onlyTextInputValidator = '^[a-zA-Z.,][a-zA-Z0-9.,-s ]*$';
export const onlyNumberInputValidator = '^[0-9]+$';
export const domainNameValidator =
  '((ftp|http|https)://)?(?:[a-z](?:[a-z]{0,61}[a-z])?.)+[a-z][a-z]{0,61}[a-z]';
export const phoneNumbervalidator = '(255|0)([0-9]{9})$';
export const newPhoneNumbervalidator = '([0-9]{9})$';
export const otpPhoneNumbervalidator = '([0-9]{9})$';
export const phoneNumbervalidatorWithPrefix = '[^0123459][0-9]{8}';
export const ipAddressValidator =
  '/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/';
export const emailAddressValidator = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


export function passwordPolicyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';

    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const isValidLength = value.length >= 8;

    const valid = hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength;

    return valid ? null : { passwordPolicy: true };
  };
}
